export enum LS_KEY {
  FORCE_TOP_USER_SHOW = 'forceTopUserShow',
}

export function useGlobalSuckState() {
  const forceTopUserShow = useState<boolean | undefined>(
    'forceTopUserShow',
    () => undefined
  )
  return {
    forceTopUserShow,
  }
}
